import React from 'react';
import {Link, NavLink, Route, Routes} from "react-router-dom";
import {withRouter} from "../src/withRouter";
import {Card, Col, Container, ListGroup, Row} from "react-bootstrap";
import * as url from "url";
import {TwitterShareButton} from "react-share";

class ESHomeNew extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            error: null,
            subscriptions: [],
            isSubscriptionsLoaded: false,
            games: [],
            isGamesLoaded: false,
            isLoaded: false,
        };
    }

    componentDidMount() {
        fetch(process.env.REACT_APP_API_URL + '/my-account/try-login-via-cache', {
            method: "POST",
            headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
        }).then(res => res.json())
            .then(
                (result) => {
                    this.setState({
                        isLoaded: true,
                        userId: result.id
                    });

                    fetch(process.env.REACT_APP_API_URL + "/customer/" + result.id.toString() + "/subscriptions?limit=9&shuffle=true", {
                        headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
                    })
                        .then(res => res.json())
                        .then(
                            (result) => {
                                this.setState({
                                    isSubscriptionsLoaded: true,
                                    isGamesLoaded: true,
                                    subscriptions: result.subscriptions,
                                    games: result.games,
                                });
                            },

                            (error) => {
                                this.setState({
                                    isLoadedSubscriptions: true,
                                    error
                                });
                            }
                        )
                },
                (error) => {
                    this.setState({
                        isLoaded: false,
                        error: error,
                    });

                    fetch(`${process.env.REACT_APP_API_URL}/customer/game/recommendations`, {
                        headers: {'Content-Type':'application/json', "Authorization": `Bearer ${sessionStorage.getItem('token')}`}
                    })
                        .then(res => res.json())
                        .then(
                            (result) => {
                                this.setState({
                                    isGamesLoaded: true,
                                    isSubscriptionsLoaded: false,
                                    games: result.games
                                });
                            },
                            // Note: it's important to handle errors here
                            // instead of a catch() block so that we don't swallow
                            // exceptions from actual bugs in components.
                            (error) => {
                                this.setState({
                                    isGamesLoaded: true,
                                    isSubscriptionsLoaded: false,
                                    error
                                });
                            }
                        )
                }
            );
    }

    shuffle(arr) {
        let array = arr;
        for (var i = array.length - 1; i > 0; i--) {
            var j = Math.floor(Math.random() * (i + 1));
            var temp = array[i];
            array[i] = array[j];
            array[j] = temp;
        }

        return array;
    };

    render() {
        const { isSubscriptionsLoaded, subscriptions, games, isGamesLoaded, isLoaded } = this.state;
        let subscriptionsFormatted = [];
        let gamesFormatted = [];

        if (!isGamesLoaded) {
            gamesFormatted = <div>Loading...</div>;
        } else {
            let gamesShuffle = this.shuffle(games);

            gamesFormatted = <div>
            <svg xmlns="http://www.w3.org/2000/svg" className="d-none">
                <symbol id="check2" viewBox="0 0 16 16">
                    <path
                        d="M13.854 3.646a.5.5 0 0 1 0 .708l-7 7a.5.5 0 0 1-.708 0l-3.5-3.5a.5.5 0 1 1 .708-.708L6.5 10.293l6.646-6.647a.5.5 0 0 1 .708 0z"></path>
                </symbol>
                <symbol id="circle-half" viewBox="0 0 16 16">
                    <path d="M8 15A7 7 0 1 0 8 1v14zm0 1A8 8 0 1 1 8 0a8 8 0 0 1 0 16z"></path>
                </symbol>
                <symbol id="moon-stars-fill" viewBox="0 0 16 16">
                    <path
                        d="M6 .278a.768.768 0 0 1 .08.858 7.208 7.208 0 0 0-.878 3.46c0 4.021 3.278 7.277 7.318 7.277.527 0 1.04-.055 1.533-.16a.787.787 0 0 1 .81.316.733.733 0 0 1-.031.893A8.349 8.349 0 0 1 8.344 16C3.734 16 0 12.286 0 7.71 0 4.266 2.114 1.312 5.124.06A.752.752 0 0 1 6 .278z"></path>
                    <path
                        d="M10.794 3.148a.217.217 0 0 1 .412 0l.387 1.162c.173.518.579.924 1.097 1.097l1.162.387a.217.217 0 0 1 0 .412l-1.162.387a1.734 1.734 0 0 0-1.097 1.097l-.387 1.162a.217.217 0 0 1-.412 0l-.387-1.162A1.734 1.734 0 0 0 9.31 6.593l-1.162-.387a.217.217 0 0 1 0-.412l1.162-.387a1.734 1.734 0 0 0 1.097-1.097l.387-1.162zM13.863.099a.145.145 0 0 1 .274 0l.258.774c.115.346.386.617.732.732l.774.258a.145.145 0 0 1 0 .274l-.774.258a1.156 1.156 0 0 0-.732.732l-.258.774a.145.145 0 0 1-.274 0l-.258-.774a1.156 1.156 0 0 0-.732-.732l-.774-.258a.145.145 0 0 1 0-.274l.774-.258c.346-.115.617-.386.732-.732L13.863.1z"></path>
                </symbol>
                <symbol id="sun-fill" viewBox="0 0 16 16">
                    <path
                        d="M8 12a4 4 0 1 0 0-8 4 4 0 0 0 0 8zM8 0a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 0zm0 13a.5.5 0 0 1 .5.5v2a.5.5 0 0 1-1 0v-2A.5.5 0 0 1 8 13zm8-5a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2a.5.5 0 0 1 .5.5zM3 8a.5.5 0 0 1-.5.5h-2a.5.5 0 0 1 0-1h2A.5.5 0 0 1 3 8zm10.657-5.657a.5.5 0 0 1 0 .707l-1.414 1.415a.5.5 0 1 1-.707-.708l1.414-1.414a.5.5 0 0 1 .707 0zm-9.193 9.193a.5.5 0 0 1 0 .707L3.05 13.657a.5.5 0 0 1-.707-.707l1.414-1.414a.5.5 0 0 1 .707 0zm9.193 2.121a.5.5 0 0 1-.707 0l-1.414-1.414a.5.5 0 0 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .707zM4.464 4.465a.5.5 0 0 1-.707 0L2.343 3.05a.5.5 0 1 1 .707-.707l1.414 1.414a.5.5 0 0 1 0 .708z"></path>
                </symbol>
            </svg>

                {/*
                            <div className="dropdown position-fixed bottom-0 end-0 mb-3 me-3 bd-mode-toggle">
                <button className="btn btn-bd-primary py-2 dropdown-toggle d-flex align-items-center" id="bd-theme"
                        type="button" aria-expanded="false" data-bs-toggle="dropdown" aria-label="Toggle theme (light)">
                    <svg className="bi my-1 theme-icon-active" width="1em" height="1em">
                        <use href="#sun-fill"></use>
                    </svg>
                    <span className="visually-hidden" id="bd-theme-text">Toggle theme</span>
                </button>
                <ul className="dropdown-menu dropdown-menu-end shadow" aria-labelledby="bd-theme-text">
                    <li>
                        <button type="button" className="dropdown-item d-flex align-items-center active"
                                data-bs-theme-value="light" aria-pressed="true">
                            <svg className="bi me-2 opacity-50 theme-icon" width="1em" height="1em">
                                <use href="#sun-fill"></use>
                            </svg>
                            Light
                            <svg className="bi ms-auto d-none" width="1em" height="1em">
                                <use href="#check2"></use>
                            </svg>
                        </button>
                    </li>
                    <li>
                        <button type="button" className="dropdown-item d-flex align-items-center"
                                data-bs-theme-value="dark" aria-pressed="false">
                            <svg className="bi me-2 opacity-50 theme-icon" width="1em" height="1em">
                                <use href="#moon-stars-fill"></use>
                            </svg>
                            Dark
                            <svg className="bi ms-auto d-none" width="1em" height="1em">
                                <use href="#check2"></use>
                            </svg>
                        </button>
                    </li>
                    <li>
                        <button type="button" className="dropdown-item d-flex align-items-center"
                                data-bs-theme-value="auto" aria-pressed="false">
                            <svg className="bi me-2 opacity-50 theme-icon" width="1em" height="1em">
                                <use href="#circle-half"></use>
                            </svg>
                            Auto
                            <svg className="bi ms-auto d-none" width="1em" height="1em">
                                <use href="#check2"></use>
                            </svg>
                        </button>
                    </li>
                </ul>
            </div>

                */}
            <svg xmlns="http://www.w3.org/2000/svg" className="d-none">
                <symbol id="bootstrap" viewBox="0 0 118 94">
                    <title>ES</title>
                    <path fillRule="evenodd" clipRule="evenodd"
                          d="M24.509 0c-6.733 0-11.715 5.893-11.492 12.284.214 6.14-.064 14.092-2.066 20.577C8.943 39.365 5.547 43.485 0 44.014v5.972c5.547.529 8.943 4.649 10.951 11.153 2.002 6.485 2.28 14.437 2.066 20.577C12.794 88.106 17.776 94 24.51 94H93.5c6.733 0 11.714-5.893 11.491-12.284-.214-6.14.064-14.092 2.066-20.577 2.009-6.504 5.396-10.624 10.943-11.153v-5.972c-5.547-.529-8.934-4.649-10.943-11.153-2.002-6.484-2.28-14.437-2.066-20.577C105.214 5.894 100.233 0 93.5 0H24.508zM80 57.863C80 66.663 73.436 72 62.543 72H44a2 2 0 01-2-2V24a2 2 0 012-2h18.437c9.083 0 15.044 4.92 15.044 12.474 0 5.302-4.01 10.049-9.119 10.88v.277C75.317 46.394 80 51.21 80 57.863zM60.521 28.34H49.948v14.934h8.905c6.884 0 10.68-2.772 10.68-7.727 0-4.643-3.264-7.207-9.012-7.207zM49.948 49.2v16.458H60.91c7.167 0 10.964-2.876 10.964-8.281 0-5.406-3.903-8.178-11.425-8.178H49.948z"></path>
                </symbol>
                <symbol id="arrow-right-short" viewBox="0 0 16 16">
                    <path fillRule="evenodd"
                          d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"></path>
                </symbol>
                <symbol id="check2-circle" viewBox="0 0 16 16">
                    <path
                        d="M2.5 8a5.5 5.5 0 0 1 8.25-4.764.5.5 0 0 0 .5-.866A6.5 6.5 0 1 0 14.5 8a.5.5 0 0 0-1 0 5.5 5.5 0 1 1-11 0z"></path>
                    <path
                        d="M15.354 3.354a.5.5 0 0 0-.708-.708L8 9.293 5.354 6.646a.5.5 0 1 0-.708.708l3 3a.5.5 0 0 0 .708 0l7-7z"></path>
                </symbol>
            </svg>

            <div className="container my-5" style={{
                backgroundColor: "lightgoldenrodyellow",
                borderRadius: 10,
                background: `linear-gradient(rgba(255, 248, 154, 0.8), rgba(255, 248, 29, 0.11)`,
            }}>
                <div className="p-5 text-center bg-body-tertiary rounded-3">
                    <svg className="bi mt-4 mb-3" width="100" height="100">
                        <img src="../public/logo512.png"></img>
                    </svg>
                    <h1 className="fw-light">Explore with Easy Street</h1>
                    <p className="lead text-body-secondary">
                        Easy Street is a revolutionary platform that seamlessly bridges the gap between users and their desired app versions, providing platform-independent access with unparalleled ease. In a digital world bursting with a multitude of app publishers, Easy Street is your one-stop destination for accessing the app versions you need, regardless of your device or operating system.</p>
                    <div className="d-inline-flex gap-2 mb-5">
                        <a href="/games" style={{textDecoration: "none"}}>
                            <button className="d-inline-flex align-items-center btn btn-outline-dark my-2"
                                    type="button">
                                Apps
                            </button>
                        </a>
                        <a href="https://www.youtube.com/watch?v=nTX9NbKgIfw" style={{textDecoration: "none"}}>
                            <button className="align-items-center btn btn-outline-dark my-2 px-4" type="button">
                                Categories
                            </button>
                        </a>
                    </div>
                </div>
            </div>

            <div className="b-example-divider"></div>

            <div className="container my-5">
                <div className="position-relative p-5 text-center text-muted bg-body border border-dashed rounded-5">

                    <svg className="bi mt-5 mb-3" width="48" height="48">
                        <use href="#check2-circle"></use>
                    </svg>
                    <h1 className="text-body-emphasis">Become publisher in 3 steps</h1>
                    <p className="col-lg-8 mx-auto fs-5 text-muted">
                        Keep everything about your game in one place.
                        Multiple Operating Systems support, integration with other stores. Application-related
                        Social Media Network.
                    </p>
                    <div className="d-inline-flex gap-2 mb-5">
                        <a href="/developer/console" style={{textDecoration: "none"}}>
                            <button className="d-inline-flex align-items-center btn btn-dark"
                                    type="button">
                                Start
                            </button>
                        </a>
                        <a href="https://www.youtube.com/watch?v=nTX9NbKgIfw" style={{textDecoration: "none"}}>
                            <button className="btn btn-outline-secondary btn btn-outline-dark" type="button">
                                Guide
                            </button>
                        </a>
                    </div>
                </div>
            </div>

            <div className="b-example-divider"></div>

            <div className="my-5">
                <div className="p-5 text-center bg-body-tertiary">
                    <div className="container py-5">
                        <h3 className="text-body-emphasis">Recommendations from ES</h3>
                        <div className="row row-cols-1 row-cols-sm-3 row-cols-md-3 g-3">
                            {gamesShuffle.map(item => (<div className="col-sm-5">
                                <div className="card shadow-sm">
                                    <div className="bd-placeholder-img card-img-top" style={{
                                        width: "100%",
                                        height: "auto"
                                    }}>
                                        <img
                                            src={item.game_page ? item.game_page.background_image_url : "http://www.w3.org/2000/svg"}
                                            width="100%" height="auto"/>
                                    </div>
                                    <div className="card-body" style={{
                                        color: "darkgray"
                                    }}>
                                        <p className="card-text">{item.name}</p>
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div className="btn-group">
                                                <button type="button" className="btn btn-sm btn-outline-secondary">
                                                    <a style={{
                                                        textDecoration: "none",
                                                        color: "darkgray"
                                                    }} href={"/games/" + item.id.toString()}>Download</a>
                                                </button>
                                                <button type="button" className="btn btn-sm btn-outline-secondary">
                                                    <span
                                                    >
                                                    <TwitterShareButton
                                                        url={"https://easy-street.herokuapp.com/games/" + item.id.toString()}
                                                        quote={item.name}
                                                        hashtag="#easystreet"
                                                    >
                                                        Share
                                                    </TwitterShareButton>
                                                </span>
                                                </button>
                                            </div>
                                            <small
                                                className="text-body-secondary">
                                                {item.status !== 'active' ?
                                                    <span style={{
                                                        float: "right",
                                                        backgroundColor: "#ffea2b",
                                                        color: "#faf19d",
                                                        borderRadius: 5,
                                                        fontWeight: "bold",
                                                        capacity: 1,
                                                        paddingLeft: 5,
                                                        paddingRight: 5
                                                    }}>
                                            {item.status.replace('_', ' ').replace('_', ' ')}
                                        </span>
                                                    : item.genre.charAt(0).toUpperCase() + item.genre.slice(1)
                                                }
                                            </small>
                                        </div>
                                    </div>
                                </div>
                            </div>))}
                        </div>
                        <br/>
                        <div style={{
                            float: "right",
                            marginBottom: 0,
                            marginRight: 0,
                        }} className="col-sm">
                            <a href="/games" className="btn btn-primary">More</a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="b-example-divider"></div>

            <div className="container my-5">
                <div className="p-5 text-center bg-body-tertiary rounded-3">
                    <h3 className="text-body-emphasis">Couple of rankings</h3>
                    <div style={{
                        marginTop: "10px"
                    }} className="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
                        <div className="col">
                            <div className="card shadow-sm">
                                <svg className="bd-placeholder-img card-img-top" width="100%" height="225"
                                     xmlns="http://www.w3.org/2000/svg" role="img"
                                     aria-label="Placeholder: Thumbnail" preserveAspectRatio="xMidYMid slice"
                                     focusable="false"><title>Most successful publisher</title>
                                    <rect width="100%" height="100%" fill="#55595c"></rect>
                                    <text x="50px" y="50%" fill="#eceeef" dy=".3em">Most successful publisher</text>
                                </svg>
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="btn-group">
                                            <button type="button"
                                                    className="btn btn-sm btn-outline-secondary">
                                                <a style={{
                                                    textDecoration: "none",
                                                    color: "darkgray"
                                                }} href={"/publishers"}>View</a>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card shadow-sm">
                                <svg className="bd-placeholder-img card-img-top" width="100%" height="225"
                                     xmlns="http://www.w3.org/2000/svg" role="img"
                                     aria-label="Placeholder: Thumbnail" preserveAspectRatio="xMidYMid slice"
                                     focusable="false"><title>Most popular category</title>
                                    <rect width="100%" height="100%" fill="#55595c"></rect>
                                    <text x="50px" y="50%" fill="#eceeef" dy=".3em">Most popular category</text>
                                </svg>
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="btn-group">
                                            <button type="button"
                                                    className="btn btn-sm btn-outline-secondary">
                                                <a style={{
                                                    textDecoration: "none",
                                                    color: "darkgray"
                                                }} href={"/categories"}>View</a>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col">
                            <div className="card shadow-sm">
                                <svg className="bd-placeholder-img card-img-top" width="100%" height="225"
                                     xmlns="http://www.w3.org/2000/svg" role="img"
                                     aria-label="Placeholder: Thumbnail" preserveAspectRatio="xMidYMid slice"
                                     focusable="false"><title>Biggest genre</title>
                                    <rect width="100%" height="100%" fill="#55595c"></rect>
                                    <text x="50px" y="50%" fill="#eceeef" dy=".3em">Biggest genre</text>
                                </svg>
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div className="btn-group">
                                            <button type="button"
                                                    className="btn btn-sm btn-outline-secondary">
                                                <a style={{
                                                    textDecoration: "none",
                                                    color: "darkgray"
                                                }} href={"/genres"}>View</a>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <br/>
                    </div>
                </div>
            </div>

            </div>
        }
            return gamesFormatted

        /*<Container>
            <Row>
                <Col>
                    <br/>
                    <center><h3>Little pig, little pig! Let me in</h3></center>
                    <div class="row">
                        <div class="col-sm">
                            {gamesFormatted}
                        </div>
                        <div class="col-sm">
                            <div className="alert alert-success">
                                <h4>Most popular genre</h4>
                            </div>
                            <br/>
                            <div className="alert alert-success">
                                <h4>Most popular category</h4>
                            </div>
                            <br/>
                            <div className="alert alert-success">
                                <h4>Most successful publisher</h4>
                            </div>
                            <br/>
                        </div>
                    </div>
                </Col>
            </Row>
        </Container>*/
    }
}

export default withRouter(ESHomeNew);
